module.exports = __webpack_public_path__ + "img/Candle.33dd933b.png";